const selector = '[data-full-hero-slider]';
const mediaQuery = '(max-width: 768px)';

const applyBackgrounds = (slides, isMobile) => {
	slides.forEach(slide => {
		const mobileSrc = slide.dataset.mobile;
		const desktopSrc = slide.dataset.desktop;
		const src = isMobile && mobileSrc ? mobileSrc : desktopSrc;
		if (src) {
			slide.style.backgroundImage = `url('${src}')`;
		}
	});
};

const initSlider = container => {
	if (container.dataset.fullHeroReady === 'true') {
		return;
	}

	const slides = Array.from(
		container.querySelectorAll('[data-full-hero-slide]')
	);
	const root = container.closest('.full-hero');
	const dots = root
		? Array.from(root.querySelectorAll('[data-full-hero-dot]'))
		: [];

	if (slides.length <= 1) {
		if (slides[0]) {
			slides[0].classList.add('is-active');
		}
		applyBackgrounds(slides, window.matchMedia(mediaQuery).matches);
		return;
	}

	container.dataset.fullHeroReady = 'true';

	let current = 0;
	const interval = parseInt(container.dataset.interval, 10) || 6000;
	let timer = null;

	const setActive = index => {
		current = index;
		slides.forEach((slide, idx) => {
			const offset = (idx - index) * 100;
			slide.style.transform = `translateX(${offset}%)`;
			slide.classList.toggle('is-active', idx === index);
		});
		dots.forEach((dot, idx) => {
			dot.classList.toggle('is-active', idx === index);
		});
	};

	const handleResize = () => {
		const isMobile = window.matchMedia(mediaQuery).matches;
		applyBackgrounds(slides, isMobile);
	};

	const startTimer = () => {
		if (timer) {
			clearInterval(timer);
		}
		timer = setInterval(() => {
			const next = (current + 1) % slides.length;
			setActive(next);
		}, interval);
	};

	handleResize();
	window.addEventListener('resize', handleResize);

	setActive(current);
	startTimer();

	dots.forEach((dot, idx) => {
		dot.addEventListener('click', () => {
			setActive(idx);
			startTimer();
		});
	});
};

document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll(selector).forEach(slider => initSlider(slider));
});
